export const TIMEZONELESS_FORMAT = 'Y-m-d\\TH:i:s';